import { Component } from '@angular/core';


/* istanbul ignore next */
/* Code coverage having problems with no statements in classes */
export class SkyPageSummaryContentComponent { static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-page-summary-content',
  template: `<div class="sky-page-summary-content">
  <ng-content></ng-content>
</div>
`,
  styles: [`.sky-page-summary-content {
  margin-top: 20px;
}
`]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
